// extracted by mini-css-extract-plugin
export default {"clickable":"Cards__clickable__CDrzF","alert-icon__container":"Cards__alert-icon__container__EnPYK"};